import React from 'react'

import { WishListTitleContainer } from './styles'

interface IWishListTitle {
    className?: string;
}

const WishListTitle: React.FC<IWishListTitle> = ({ className, children }) => (
    <WishListTitleContainer className={className}>
        {children}
    </WishListTitleContainer>
)

export default WishListTitle